import React, {useEffect, useState} from 'react';
import {FiltersBar} from '../../../components/ui/FiltersBar';
import {userData} from '../../../util/userData';
import {CoachingFormsContainer} from '../../CoachingFormsContainer';
import {
  getActionAlertsAttachedStatus,
  getIndividualSurveysStatuses,
  getIndividualSurveysStatusTypes,
  loadIndividualSurveys,
  markIndividualSurveyAsRead,
  resetFilters,
  selectDashboardState,
  selectRecords,
  setSelectedAllIndividualInterviewsIds,
  setSelectedNoneIndividualInterviewsIds,
  toggleIndividualSurveyAsActionItem,
  toggleIndividualSurveyAsWowItem,
  toggleIndividualSurveyAsSalesOpportunity,
  toggleIndividualSurveyFilter,
  toggleSelectedIndividualSurvey,
  updateGetQuestionsList,
  updateStatusFilter, deleteIndividualSurveysSelection,
} from '../dashboard/dashboardSlice';
import {selectFilters, updateFilters} from '../filters/filtersSlice';
import {useAppDispatch, useAppSelector} from '../hooks';

export const IndividualSurveysDashboard = () => {
  const filters = useAppSelector(selectFilters);
  const componentState = useAppSelector(selectDashboardState);
  const isLoading = componentState.isLoading;
  const actionAlertAttachedStatus = componentState.actionAlertsAttachedStatus;
  const individualSurveysFilters = componentState.individualSurveysFilters;
  const statusFilters = componentState.individualSurveysStatusFilter;
  const selectedIndividualSurveyIds = componentState.selectedIndividualSurveysIds;
  const dataGridRecords = useAppSelector(selectRecords);
  const data = componentState.apiResponse;
  const getQuestionsList = componentState.getQuestionsList;
  const dispatch = useAppDispatch();
  // @ts-ignore
  const actionItemFilter = getParameterByName('ai');
  // @ts-ignore
  const perfectScoreFilter = getParameterByName('ps');
  // @ts-ignore
  const wowFilter = getParameterByName('wow');
  // @ts-ignore
  const salesOpportunity = getParameterByName('so');
  // @ts-ignore
  const attritionRisk = getParameterByName('ar');

  const [isDashboardLoading, setIsDashboardLoading] = useState(false);

  useEffect(() => {
    userData.filtersListen((updatedFilters) => {
      dispatch(updateFilters(updatedFilters));
      dispatch(resetFilters());

      window.addEventListener("message", notesListener)

    });
  }, []);

  const notesListener = (msgEvent: MessageEvent) =>{
    if (msgEvent && msgEvent.data && msgEvent.data.indexOf&&msgEvent.data.indexOf('updateHasNotes') > -1) {
      console.log('this is where we need to add a refresh on data')
    }
  }


  useEffect(() => {
    const filtersList = Object.keys(filters);
    if (filtersList.length) {
      dispatch(loadIndividualSurveys(filters));
      dispatch(getIndividualSurveysStatusTypes());
      dispatch(getIndividualSurveysStatuses());
    }
    if (filtersList.includes('hier') && filtersList.includes('survey')) {
      const hierarchyFilter = filters.hier;
      const surveyFilter = filters.survey;
      dispatch(updateGetQuestionsList(hierarchyFilter.toString().length > 0 && surveyFilter.toString().length > 0));
    }
  }, [filters]);

  useEffect(() => {
    dispatch(getActionAlertsAttachedStatus(dataGridRecords));
  }, [data])

  useEffect(() => {
    setIsDashboardLoading(isLoading)
  }, [componentState])

  return (
    <main>
      <FiltersBar
        hideQuestions
        hideMetrics
        hideCommentTypes
        showAllCoachingFormOption
        showMonthPicker
        useNewContainer
        dateRangeDataFetchStatus={isDashboardLoading}
      />
      <CoachingFormsContainer
        filtersForQuestionsPopup={filters}
        filtersForQuestionsReady={getQuestionsList}
        isLoading={isLoading}
        individualSurveysStatusFilter={statusFilters}
        individualSurveysFilters={individualSurveysFilters}
        coachingData={data}
        initialPerfectScoreFilter={perfectScoreFilter === 'true'}
        initialWowFilter={wowFilter === 'true'}
        initialActionItemFilter={actionItemFilter === 'true'}
        initialSalesOpportunity={salesOpportunity === 'true'}
        initialAttritionRisk={attritionRisk === 'true'}
        records={dataGridRecords}
        statuses={componentState.legacyStatuses}
        actionAlertAttachedStatus={actionAlertAttachedStatus}
        statusTypes={componentState.normalizedStatusTypes}
        statusTypesList={componentState.statusTypes}
        selectedCoachingFormIds={selectedIndividualSurveyIds}
        toggleFilter={(selectedFilter) => {
          dispatch(toggleIndividualSurveyFilter(selectedFilter))
        }}
        updateStatusFilter={(statusFilterId) => {
          dispatch(updateStatusFilter(statusFilterId))
        }}
        setSelectedAllIndividualInterviewsIds={() => {
          dispatch(setSelectedAllIndividualInterviewsIds(dataGridRecords));
        }}
        setSelectedNoneIndividualInterviewsIds={() => {
          dispatch(setSelectedNoneIndividualInterviewsIds());
        }}
        toggleSelectedCoachingForm={(individualSurvey) => {
          dispatch(toggleSelectedIndividualSurvey(individualSurvey))
        }}
        resetDataGridFilters={() => {
          dispatch(resetFilters())
        }}
        markAsRead={(record) => {
          dispatch(markIndividualSurveyAsRead(record))
        }}
        toggleWow={(record) => {
          dispatch(toggleIndividualSurveyAsWowItem(record))
        }}
        toggleIsSalesOpportunity={(record) => {
          dispatch(toggleIndividualSurveyAsSalesOpportunity(record))
        }}
        updateStatusSection={() => {
          dispatch(getActionAlertsAttachedStatus(dataGridRecords));
          dispatch(getIndividualSurveysStatuses());
        }}
        toggleIndividualSurveyAsActionItem={(record) => {
          dispatch(toggleIndividualSurveyAsActionItem(record))
        }}
        deleteIndividualSurveysSelection={() => {
          dispatch(deleteIndividualSurveysSelection());
        }}
      />
    </main>
  );
};
